import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  alerts: [],
  patrolPoints: [],
  pendingReports: [],
  loading: false,
  error: null
};

export const securitySlice = createSlice({
  name: 'security',
  initialState,
  reducers: {
    fetchAlertsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchAlertsSuccess: (state, action) => {
      state.alerts = action.payload;
      state.loading = false;
      state.error = null;
    },
    fetchAlertsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchPatrolPointsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchPatrolPointsSuccess: (state, action) => {
      state.patrolPoints = action.payload;
      state.loading = false;
      state.error = null;
    },
    fetchPatrolPointsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    updatePatrolPointStatus: (state, action) => {
      const { id, status } = action.payload;
      const point = state.patrolPoints.find(p => p.id === id);
      if (point) {
        point.status = status;
        point.lastChecked = new Date().toISOString();
      }
    },
    addSecurityAlert: (state, action) => {
      state.alerts.unshift(action.payload);
    },
    resolveAlert: (state, action) => {
      const alertId = action.payload.id;
      const alert = state.alerts.find(a => a.id === alertId);
      if (alert) {
        alert.status = 'resolved';
        alert.resolvedBy = action.payload.resolvedBy;
        alert.resolvedAt = new Date().toISOString();
        alert.resolution = action.payload.resolution;
      }
    }
  },
});

export const { 
  fetchAlertsStart, 
  fetchAlertsSuccess, 
  fetchAlertsFailure,
  fetchPatrolPointsStart,
  fetchPatrolPointsSuccess,
  fetchPatrolPointsFailure,
  updatePatrolPointStatus,
  addSecurityAlert,
  resolveAlert
} = securitySlice.actions;

export default securitySlice.reducer; 